import {getMonthText, lastThreeMonths} from './forms/lib/utils';
import {ressourcesList} from './forms/lib/liste-ressources';

const get_nationalite_individu = (individu)=> {
		if (typeof individu.nationalite !== 'undefined') {
			let data_nat = '';
			switch (individu.nationalite) {
				case 'FR':
					data_nat = 'Française';
					break;
				case 'EEE - UE - Suisse':
					data_nat = 'EEE - UE - Suisse';
					break;
				case 'Hors UE':
					data_nat = 'Hors UE';
					break;
				default:
					data_nat = 'Francaise';
					break;
			}
			return <>Nationalit&eacute; <span className='bold'>	{data_nat }</span></>;
		}
		return '';
}

const get_situation_individu = (individu)=> {
	let data_situation = '';
	if (typeof individu.activite !== 'undefined') {
		//
		switch (individu.activite) {
			case 'etudiant':
				data_situation = 'Etudiant(e)/Apprenti(e)';
				break;
			case 'chomeur':
				data_situation = 'Chômeur';
				break;
			case 'retraite':
				data_situation = 'Retraité(e)';
				break;
			default:
				break;
		}
		if (data_situation !== '') {
			data_situation = <span className="bold">{data_situation}</span>;
		}
	}
	return data_situation;
}//

const get_statut_marital =	(famille , _conjoint , individu)=> {
	if (!famille.en_couple && typeof _conjoint !== 'undefined')
		return 'Célibataire';

	let data_statut_marital = '';
	if (typeof _conjoint !== 'undefined') {
		data_statut_marital = individu.statut_marital;
		switch (data_statut_marital) {
			case 'marie':
				data_statut_marital = 'Marié-e';
				break;
			case 'pacse':
				data_statut_marital = 'Pascé-e';
				break;
			case 'non_renseigne':
				data_statut_marital = 'En union libre';
				break;
			default:
				data_statut_marital = 'En union libre';
				break;
		}
	}
	return data_statut_marital;
}

const map_ressources = function (id ) {
	const ressource = ressourcesList.find((r) => r.name === id);
	const mapRessources = {
		salaire_imposable: 'Salaire',
		ppa: 'Prime activite'
	};

	if (ressource) {
		return ressource.label;
	}

	if (mapRessources[id]) {
		return mapRessources[id];
	}

	return id;
};

const add_ressource_to_recap = function ( ressources , ressources_personne , ress_id , thisMonth ) {
	const currentDate = new Date();
		const currentMonth = currentDate.getMonth();
		let previousMonthDate;
		if (currentMonth === 0) {
		  previousMonthDate = new Date(currentDate.getFullYear() - 1, 12, 1);
		} else {
		  previousMonthDate = new Date(currentDate.getFullYear(), currentMonth - 1, 1);
		}
		previousMonthDate =  previousMonthDate.toISOString().slice(0, 7);

		let ignore = ['salaire_net', 'salaire_de_base', 'retraite_brute', 'chomage_brut'];
		let rev_pro_non_salarie = [
				'tns_auto_entrepreneur_chiffre_affaires',
				'tns_benefice_exploitant_agricole',
				'tns_micro_entreprise_chiffre_affaires',
				'tns_autres_revenus'
		];
		
		if (!ignore.includes(ress_id)) {
			if (!rev_pro_non_salarie.includes(ress_id) && !ressources_personne[ress_id].detailler) {
				let ressource = ressources_personne[ress_id][thisMonth];

				ressource = ressource === null || typeof ressource === 'undefined' ? 0 : ressource;
				ressource = ressource % 1 === 0 ? ressource : ressource.toFixed(3);
				let data_ressource =<p className="ress_regular">
									{map_ressources(ress_id)}<span className='bold'>{ressource}€</span>
								</p>;

				if (ressource !== null && ressource > 0){
					ressources.push(data_ressource);
				} else {					
					data_ressource =<p className='month-ress'>
						{ map_ressources(ress_id)} ({getMonthText(previousMonthDate)}) <span className='bold'>{ressources_personne[ress_id][previousMonthDate]} €</span>
					</p>;
					ressources.push(data_ressource);

					
				}
			}
		}
}
/* */
const init_recap = function (demandeur, enfants, conjoint, logement, ressources,_props) {
		const date = new Date();
		const year = date.getFullYear();
		const {step, individus, famille, foyer_fiscal, menage} = _props;
		const _conjoint = _props.conjoint;
		const individu = _props.demandeur;

		var thisMonth = year + '-' + ('0' + (date.getMonth() + 1)).slice(-2);
		// recapitulatif demandeur
		var nombre_enfant = Object.keys(individus).length;

		if (individu !== undefined && individu.age) {
			// age
			var data_age = <>Ag&eacute;.e de <span className='bold'>{individu.age }</span> an.s</>;

			demandeur.push(data_age);

			// nationalite
			var data_nat = get_nationalite_individu(individu);
			demandeur.push(data_nat);
			

			// situation specifique
			var data_situation = get_situation_individu(individu);
			if (data_situation !== '') demandeur.push(data_situation);

			// statut marital
			var data_statut_marital = get_statut_marital(famille,_conjoint,individu);

			// Precision sur situation familliale
			var data_famille = data_statut_marital;

			/*if (nombre_enfant) {
				let data_enfants = nombre_enfant + ' enfant(s)';
				data_famille = data_famille === '' ? data_enfants : data_famille + '/' + data_enfants;
			}*/

			data_famille = data_famille !== '' ? <span className='bold'>{data_famille}</span> : '';//
	
			if (data_famille !== '') {
				demandeur.push(data_famille);
			}
		}

		// recapitulatif enfant
		if (nombre_enfant > 0) {
			let nb_enfant = <p> {nombre_enfant} enfant.s à charge </p>;//

			enfants.push(nb_enfant);

			Object.keys(individus).forEach((enf_id)=>{
				let enfant = individus[enf_id];

				let data_enfant = <><span className='bold'> {enfant.name }</span> {enfant.age} an.s {enfant.garde_alternee ? ", garde alternée" :""}</>;

				enfants.push(data_enfant);
			});
		}

		// recapitulatif conjoint
		if (famille.en_couple && typeof _conjoint !== 'undefined') {
			let stat_marital_conj, nat_conj, situation_conj;

			let conj_age = <>Ag&eacute;.e de <span className='bold'>{_conjoint.age }</span> an.s</>;//
			conjoint.push(conj_age);

			nat_conj = get_nationalite_individu(_conjoint);
			conjoint.push(nat_conj);

			situation_conj = get_situation_individu(_conjoint);
			if (situation_conj !== '') conjoint.push(situation_conj);

			stat_marital_conj = <span className='bold'> {get_statut_marital(famille,_conjoint,individu)}</span>;//
			conjoint.push(stat_marital_conj);
		}
				// recapitulatif logement
		let logement_valid = menage.statut_occupation_logement && menage.depcom; //
		if (logement_valid) {
			let data_type_logement, data_loyer, data_charge_loc, data_logement_chambre, data_situation_log;
			let is_autre_logement = false;

			data_situation_log = menage.statut_occupation_logement;

			if (data_situation_log === 'locataire_vide') {
				data_loyer = menage.loyer; // loyer
				data_charge_loc = menage.charges_locatives;
				data_logement_chambre = menage.logement_chambre; // logement chambre
				data_situation_log = 'Locataire';
				data_type_logement = 'Non meublé';
			} else if (data_situation_log === 'locataire_meuble') {
				data_loyer = menage.loyer; // loyer
				data_logement_chambre = menage.logement_chambre; // logement chambre
				data_situation_log = 'Locataire';
				data_type_logement = 'Meublé';
			} else if (data_situation_log === 'locataire_foyer') {
				data_loyer = menage.loyer; //loyer
				data_charge_loc = menage.charges_locatives;
				data_situation_log = 'Locataire';
				data_type_logement = 'Foyer';
			} else {
				is_autre_logement = true;
				let autre_situations_logement = {
					primo_accedant: 'Propriétaire (primo accédant)',
					proprietaire: 'Propriétaire',
					sans_domicile: 'Sans domicile',
					non_renseigne: 'Non renseigné',
					loge_gratuitement: 'Héberger'
				};
				data_situation_log = autre_situations_logement[data_situation_log];

				if (typeof data_situation_log !== 'undefined') {
					data_situation_log = <span className='bold'>{ data_situation_log }</span>;
					logement.push(data_situation_log);
					//	charge mensuel proprietaire
					if (typeof menage.loyer !== 'undefined') {
						data_loyer = <p>charges mensuelle <span className='bold'>{menage.loyer} €</span> </p>;
						logement.push(data_loyer);
					}
				}
			}

			if (!is_autre_logement) {
				data_situation_log = <span className='bold'> {data_situation_log} {data_logement_chambre ? '(Chambre)':''}</span>;
				data_type_logement = <span className='bold'>{data_type_logement} </span>;
				data_loyer = <>Loyer <span className='bold'>{data_loyer }€</span></>;

				logement.push(data_situation_log);
				logement.push(data_type_logement);
				logement.push(data_loyer);

				if (data_charge_loc) {
					data_charge_loc = <>Charge locatives <span className='bold'>{data_charge_loc }€</span></>;
					logement.push(data_charge_loc);
				}
			}
		}
		
		// recapitulatif ressources
		let ressources_valid = typeof individu.ressources !== 'undefined';
		if (ressources_valid) {
			
			
			// Ressources demandeur .

			if (individu && individu.ressources) {
				ressources.push(<p className='sub-title'>Vos Ressources</p>);
				let ressources_personne = individu.ressources;

				for (let ress_id in ressources_personne) {
					add_ressource_to_recap(ressources , ressources_personne , ress_id);
				}
			}
			// Ressources conjoint .
			if (_conjoint && _conjoint.ressources) {
				ressources.push(<p className='sub-title'>Ressources Conjoint</p>);
				let ressources_personne = _conjoint.ressources;

				for (let ress_id in ressources_personne) {
					add_ressource_to_recap(ressources , ressources_personne , ress_id);
				}
			}

			// Ressources enfants .
			const liste_enfant_ayant_ressources = Object.keys(individus).filter((id)=>{
				if ( typeof individus[id].ressources !== undefined){
					return id;
				}
				return false;
			});
			if (liste_enfant_ayant_ressources.length > 0) {
				for (let n = 0; n < liste_enfant_ayant_ressources.length; n++) {
					let enfant_id = liste_enfant_ayant_ressources[n];
					let enfant = individus[enfant_id];

					if (enfant && enfant.ressources) {
						ressources.push(<p className='sub-title'>Ressources de	{enfant.name.toLowerCase()} </p>);
						let ressources_personne = enfant.ressources;

						for (let ress_id in ressources_personne) {
							add_ressource_to_recap(ressources , ressources_personne , ress_id);
						}
					}
				}
			}
		}	

	}


export {init_recap};